import {
  IAnalyticsEventsTracker,
  IAnalyticsTargetedEventsTracker,
  TargetedEventsTracker,
  GTMEventsTracker,
  TargetedConsoleLogEventsTracker,
} from '@verv-inc/js-toolkit/core-analytics';
import { EVENT_TRACKERS } from './types';
import { AmplitudeEventsTracker } from './amplitudeEventsTracker';

const composeAnalyticsEventsTracker = (): IAnalyticsTargetedEventsTracker => {
  const trackersMap = new Map<EVENT_TRACKERS, IAnalyticsEventsTracker>();

  trackersMap.set(EVENT_TRACKERS.GTM, AmplitudeEventsTracker());

  const targetedEventsTracker = TargetedEventsTracker(trackersMap);

  if (process.env.ENVIRONMENT === 'dev') {
    return TargetedConsoleLogEventsTracker(targetedEventsTracker);
  }

  return targetedEventsTracker;
};

export const analyticsEventsTracker: IAnalyticsTargetedEventsTracker = composeAnalyticsEventsTracker();
